import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

export type FabricToastShowMessageOptions = {
  /**
   * Icon 类型
   */
  icon?: 'success' | 'error' | 'warn';
  /**
   * 是否显示背景遮罩层, 默认显示, 遮罩层会覆盖住navbar.
   * @default true
   */
  mask?: boolean;
  /**
   * 自定义加载标题
   */
  message: string;
  /**
   * 关闭时间 [2000, 3500] 之间
   * @default 2000
   */
  expireTime?: number;
};

export type FabricToastShowMessageApi = (
  options: FabricToastShowMessageOptions
) => Promise<boolean>;

/**
 * 弹出toast tip message
 * @param options
 */
export const showMessage: FabricToastShowMessageApi = (
  options: FabricToastShowMessageOptions
) => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<
      'fabric_toast.showMessage',
      FabricToastShowMessageOptions,
      boolean
    >(
      'fabric_toast.showMessage',
      {
        icon: options.icon,
        mask: options.mask ?? true,
        message: options.message || '',
        expireTime: options.expireTime || 2000,
      },
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
